
{
  "userMenu": {
    "profile": "個人資料",
    "myListings": "我的列表",
    "myFavorites": "我的收藏",
    "referFriend": "推薦朋友"
  },
  "profile": {
    "title": "個人資料設定",
    "personalInfo": "個人資訊",
    "accountSettings": "帳戶設定",
    "referral": {
      "title": "推薦朋友",
      "description": "分享您的推薦連結，當朋友註冊時獲得獎勵",
      "copy": "複製連結",
      "copiedSuccess": "推薦連結已複製！",
      "copiedDescription": "與您的朋友分享此連結",
      "referViaWhatsapp": "透過WhatsApp推薦"
    }
  },
  "listings": {
    "title": "我的列表",
    "empty": {
      "title": "尚無列表",
      "description": "創建您的第一個列表以開始吸引客戶",
      "cta": "創建列表"
    },
    "status": {
      "pending": "待審核",
      "approved": "已啟用",
      "rejected": "已拒絕"
    }
  },
  "favorites": {
    "title": "我的收藏",
    "empty": {
      "title": "尚無收藏",
      "description": "保存您感興趣的服務提供者",
      "cta": "瀏覽服務"
    }
  },
  "analytics": {
    "title": "分析",
    "views": "瀏覽次數",
    "contacts": "聯繫次數",
    "performance": "表現"
  }
}
